import type { LocalizedMessage } from './Locale.svelte';

const ERROR = '_translation-not-found';

const _translation = new Map();
_translation.set(ERROR, {
	default: 'translation not found',
	en: 'translation not found'
});

export function registerTranslation(key: string, translation: LocalizedMessage) {
	_translation.set(key, translation);
	return _translation;
}

export function registerTranslations(items: { key: string; message: LocalizedMessage }[]) {
	items.map((i) => registerTranslation(i.key, i.message));
	return _translation;
}

export function getGlobalTranslation(key: string): LocalizedMessage|null {
	const translation = _translation.get(key);
	if (translation) return translation;
	return null;
}

export type TranslationFormat = [string, string];
export type TranslationFileFormat = { [keyof: string]: TranslationFormat[] };

export function parsesTranslations(items: TranslationFileFormat): { key: string; message: LocalizedMessage }[] {
	const keys: {
		[keyof: string]: { [keyof: string]: string };
	} = {};

	for (let lang of Object.keys(items)) {
		items[lang].forEach((key) => {
			if (!keys[key[0]]) keys[key[0]] = {};
			keys[key[0]][lang] = key[1];
		});
	}

	return Object.entries(keys).map((e) => ({ key: e[0], message: e[1] as LocalizedMessage }));
}
